import moment from 'moment';

export const findIndex = <T = Recordable>(ary: Array<T>, fn: Fn): number => {
	if (ary.findIndex) {
		return ary.findIndex(fn);
	}
	let index = -1;
	ary.some((item: T, i: number, ary: Array<T>) => {
		const ret: T = fn(item, i, ary);
		if (ret) {
			index = i;
			return ret;
		}
	});
	return index;
};

/* 通用的格式化集合 */
export const formatTools = () => {
	return {
		fDate: (date: any, msg?: string) => {
			return !date ? msg ?? '--' : moment(date).format('YYYY/MM/DD');
		},
		fDateTime: (time: any) => {
			return !time ? '--' : moment(time).format('YYYY/MM/DD HH:mm');
		},
		fAmount: (value: any) => {
			return !value ? 0.0 : value.toLocaleString('zh-CN', { style: 'currency', currency: 'CNY' });
		},
		fScale: (value: any) => {
			return !value ? '0.00%' : `${value.toFixed(2)}%`;
		},
	};
};

/* 金额转大写 */
export const RmbcCpital = (amount: number): string => {
	const fraction = ['角', '分'];
	const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
	const unit = [
		['元', '万', '亿'],
		['', '拾', '佰', '仟'],
	];
	const head = amount < 0 ? '欠' : '';
	amount = Math.abs(amount);

	let s = '';

	for (let i = 0; i < fraction.length; i++) {
		s += (digit[Math.floor(amount * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
	}
	s = s || '整';
	amount = Math.floor(amount);

	for (let i = 0; i < unit[0].length && amount > 0; i++) {
		let p = '';
		for (let j = 0; j < unit[1].length && amount > 0; j++) {
			p = digit[amount % 10] + unit[1][j] + p;
			amount = Math.floor(amount / 10);
		}
		s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
	}

	return (
		head +
		s
			.replace(/(零.)*零元/, '元')
			.replace(/(零.)+/g, '零')
			.replace(/^整$/, '零元整')
	);
};

/* 数组深复制 */
export const deepClone = (obj: any): any => {
	let result;

	if (typeof obj !== 'object' || obj === null) return obj;

	if (Array.isArray(obj)) {
		result = [];

		for (let i = 0; i < obj.length; i++) {
			result[i] = deepClone(obj[i]);
		}
	} else {
		result = {};

		for (const key in obj) {
			result[key] = deepClone(obj[key]);
		}
	}

	return result;
};
